<div class="w-full flex justify-content-center">
    <div class="card flex flex-column align-items-center container-card">
        <div class="font-bold text-4xl">
            {{ 'sipo.payment-component.credit-selection-component.recharge-credit' | translate }}
        </div>
        <div class="text-xl mt-3">
            {{ 'sipo.payment-component.credit-selection-component.choose-amount' | translate }}
        </div>
        <div class="mt-5 flex w-full" [formGroup]="form">
            <!--left field begin-->
            <div class="w-6 flex flex-column">
                <div class="mb-3">
                    <input type="radio" name="creditAmount" formControlName="creditAmount" value="10">
                    <label class="font-bold text-lg">{{ 10 | currencyFormat }}</label>
                </div>
                <div class="mb-3">
                    <input type="radio" name="creditAmount" formControlName="creditAmount" value="20">
                    <label class="font-bold text-lg">{{ 20 | currencyFormat }}</label>
                </div>
                <div class="mb-3">
                    <input type="radio" name="creditAmount" formControlName="creditAmount" value="30">
                    <label class="font-bold text-lg">{{ 30 | currencyFormat }}</label>
                </div>
                <div class="flex w-full justify-content-between align-items-center mb-3">
                    <div>
                        <input type="radio" name="creditAmount" formControlName="creditAmount"
                               value="50">
                        <label class="font-bold text-lg">{{ 50 | currencyFormat }}</label>
                    </div>
                </div>
                <div class="flex w-full justify-content-between align-items-center mb-3">
                    <div>
                        <p-inputNumber
                            formControlName="customAmount"
                            mode="currency"
                            currency="EUR"
                            locale="de-DE"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            class="w-5rem border-round-lg border-gray-200 p-1">
                        </p-inputNumber>
                    </div>
                </div>

            </div>
            <!--left field end-->
            <p-divider layout="vertical"></p-divider>
            <!--right field begin-->
            <div class="w-6">
                <!--Price card begin-->
                <div>
                    <div class="font-bold text-2xl mb-2">
                        {{ 'sipo.payment-component.order-overview' | translate }}
                    </div>
                    <div
                        class="flex w-full justify-content-between align-items-center text-lg mb-2">
                        <span>{{ 'sipo.payment-component.pay-component.price' | translate }}:</span>
                        <span class="font-bold"> {{ formattedPrice  | currencyFormat }}</span>
                    </div>
                    <div class="flex w-full justify-content-between align-items-center text-lg">
                        <span>{{ 'sipo.payment-component.pay-component.vat' | translate }}:</span>
                        <span class="font-bold">
                            {{ formattedVat  | currencyFormat }}
                        </span>
                    </div>
                    <p-divider></p-divider>
                    <div class="flex w-full justify-content-between align-items-center text-lg">
                        <span>{{ 'sipo.payment-component.pay-component.total-amount' | translate }}:</span>
                        <span
                            class="font-bold">{{ formattedTotal | currencyFormat }}</span>
                    </div>
                </div>

                <div class="mt-3">
                    <!-- Fehlermeldung -->
                    <p-message *ngIf="errorMessage"
                               severity="error"
                               [text]="errorMessage"
                    ></p-message>
                </div>

                <div class="w-full mt-auto">
                    <button (click)="nextStep()"
                            class="p-button bg-secondary flex justify-content-center w-full">
                        {{ 'sipo.payment-component.credit-selection-component.reacharge-now' | translate }}
                    </button>
                </div>
                <!--Price card end-->
            </div>
            <!--right field end-->
        </div>
    </div>
</div>
